import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useTranslatableField } from 'utils/useTranslatableField';
import { ActionButton, ButtonType } from 'components/Atoms/ActionButton/ActionButton';
import { MOBILE_MEDIA_QUERY } from 'utils/constants';
import { useMediaQuery } from '@react-hook/media-query';
import { useExitRedirect } from 'utils/useExitRedirect';
import { LiveContext } from 'src/context/LiveContext';
import { SurveyTypes } from 'types/survey';
import { Dialog } from '../../Atoms/Dialog/Dialog';
import { Icon } from '../../Atoms/Icon/Icon';
import { Flex } from '../../Atoms/Flex/Flex';
import { PageContext } from '../../../context/PageContext';
import styles from './SurveyExitPopup.module.scss';

export function SurveyExitPopup() {
  const { survey, urlParams } = useContext(PageContext);
  const [popupOpen, setPopupOpen] = useState(false);
  const { t } = useTranslation();
  const { translateField } = useTranslatableField(urlParams?.locale);
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);

  const isLiveEngagement = survey?.type === SurveyTypes.LIVE;
  const { exitEngagement } = useContext(LiveContext);

  const endLiveEngagement = () => {
    if (exitEngagement) {
      exitEngagement();
    }
    setPopupOpen(false);
  };

  const exitRedirect = useExitRedirect();
  return (
    <>
      <button
        id="closeSurveyButton"
        type="button"
        aria-label={t('icons.close')}
        onClick={() => {
          setPopupOpen(true);
        }}
      >
        <Icon name="close" width={24} height={24} />
      </button>
      {popupOpen && (
        <Dialog
          open={!!popupOpen}
          setOpen={() => {
            setPopupOpen(false);
          }}
          close
          classname={styles.dialog}
          title={
            <div className={styles.title}>
              <Icon classname={styles.icon} name="errorCard" />
              <div>{t('survey.exitTitle')}</div>
            </div>
          }
          description={<>{t('survey.exitDescription')}</>}
          descriptionClassname={styles.description}
          content={
            <Flex
              flexDirection={isMobile ? 'column' : 'row'}
              alignItems="center"
              justifyContent="center"
              gap={16}
              className={styles.actionContainer}
            >
              <ActionButton
                type={ButtonType.CANCEL}
                className={styles.actionButton}
                onClick={() => {
                  setPopupOpen(false);
                }}
              >
                {t('survey.exitBack')}
              </ActionButton>
              {!isLiveEngagement && (
                <ActionButton type={ButtonType.ACTION} className={styles.actionButton} href={exitRedirect}>
                  {translateField(survey?.configuration?.exit_button_text) || t('survey.exitButton')}
                </ActionButton>
              )}
              {isLiveEngagement && (
                <ActionButton
                  type={ButtonType.ACTION}
                  className={styles.actionButton}
                  onClick={() => {
                    setPopupOpen(false);
                    endLiveEngagement();
                  }}
                >
                  {translateField(survey?.configuration?.exit_button_text) || t('survey.exitButton')}
                </ActionButton>
              )}
            </Flex>
          }
        />
      )}
    </>
  );
}
